import { call, put, select, takeLatest } from 'typed-redux-saga'
import { FrontUrls } from 'Constants/FrontUrls'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { FormNames } from 'Constants/FormNames'
import { ResponseCatalog } from 'Models'
import { Deserialize } from 'cerialize'
import {
	BgLimitRequestNs,
	bgLimitRequestSlice,
	bgLimitRequestSelector,
	BgLimitRequestFull,
	getBgIdFromLocation,
	AST_ERROR_KEYS,
	AST_ERROR_CODE,
	DEFAULT_ERROR_PARAMS,
	MessageType,
	BgMessage,
	BgLimitRequest,
	BankGuarantee,
	astMessageTitleByStatus,
	bgLimitRequestApi,
} from 'Pages/ibro'
import { SocketMessageTypes } from 'Modules/Socket'

export function* getLimitRequestItem(id: number) {
	const res = yield* call(bgLimitRequestApi.getLimitRequest, id)
	const data = Deserialize(res, BgLimitRequestFull)
	yield* put(bgLimitRequestSlice.actions.setLimitRequest({ data }))
}

function* updateLimitRequestSaga(action: BgLimitRequestNs.UpdateStatus) {
	try {
		const { id, status, request_type, errors, changes } = action.payload
		const currentBgId = getBgIdFromLocation(FrontUrls.broker.index)

		if (status) {
			if (request_type !== SocketMessageTypes.CHECK_STATUS || changes?.status) {
				const data = [id.toString()]
				yield* call(notifyMessageCreator, 'broker.update_status.success', { data })
			}
		} else {
			const astErrors =
				errors &&
				errors.filter((error) =>
					Object.keys(error as {}).some((key) => AST_ERROR_KEYS.includes(key as AST_ERROR_CODE))
				)

			if (currentBgId === id && (!astErrors || !astErrors.length)) {
				yield* call(
					errorHandler,
					{
						data: {
							errors: errors || [],
						},
						...DEFAULT_ERROR_PARAMS,
					},
					FormNames.BROKER.LIMIT
				)
			} else {
				yield* put(
					bgLimitRequestSlice.actions.setBgMessage(
						new BgMessage(MessageType.DANGER, {
							title: astMessageTitleByStatus[request_type] ?? '',
							message: (errors && Object.values(errors[0] as string)?.[0]) || '',
						})
					)
				)
			}
		}

		if (currentBgId === id) {
			yield* call(getLimitRequestItem, id)
		} else if (
			(request_type === SocketMessageTypes.CHECK_STATUS && changes?.status) ||
			(request_type !== SocketMessageTypes.CHECK_STATUS && status)
		) {
			const limitRequestList = yield* select(bgLimitRequestSelector.selectLimitRequestList)
			const findIndex = limitRequestList?.findIndex((bg) => bg.id === id)
			if (findIndex + 1) {
				const newLimitRequest = yield* call(bgLimitRequestApi.getLimitRequest, id)
				const updatedList = Object.assign(new ResponseCatalog<BgLimitRequest>(), limitRequestList, {
					entries: limitRequestList.map(
						(bg): BankGuarantee =>
							bg.id === id ? Deserialize(newLimitRequest, BgLimitRequest) : bg
					),
				})
				yield* put(bgLimitRequestSlice.actions.setLimitRequestList(updatedList))
			}
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* limitRequestSocketSaga() {
	yield* takeLatest(
		bgLimitRequestSlice.actions.updateLimitRequestStatus.type,
		updateLimitRequestSaga
	)
}
